@if (hotelThumbnailImage) {
  <img src="{{hotelThumbnailImage}}" />
}
@if (!hotelThumbnailImage) {
  <img src="assets/images/hotel/hotel.png" />
}